module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Bold-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Bold-webfont.ttf
// module id = 1617
// module chunks = 0